'use client'

import React from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { Home, GraduationCap, User, Menu } from 'lucide-react'

interface MobileBottomNavProps {
  onMenuClick?: () => void
}

export const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ onMenuClick }) => {
  const pathname = usePathname()

  const navItems = [
    {
      href: '/',
      icon: Home,
      label: 'Home',
      isActive: pathname === '/',
    },
    // {
    //   href: '/saac-camps',
    //   icon: GraduationCap,
    //   label: 'Camps',
    //   isActive: pathname.startsWith('/camps'),
    // },
    {
      href: '/dashboard',
      icon: User,
      label: 'Profile',
      isActive: pathname.startsWith('/dashboard'),
    },
    {
      href: '#',
      icon: Menu,
      label: 'Menu',
      isActive: false,
      onClick: onMenuClick,
    },
  ]

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 bg-black/95 text-white shadow-lg backdrop-blur-sm md:hidden">
      <div className="flex items-center justify-around px-4 py-3">
        {navItems.map((item, index) => {
          const Icon = item.icon

          if (item.onClick) {
            return (
              <button
                key={index}
                onClick={item.onClick}
                className="flex flex-col items-center justify-center p-2 transition-all duration-200 hover:scale-105 hover:text-accent"
                aria-label={item.label}
              >
                <Icon
                  className={`h-8 w-8 transition-colors ${
                    item.isActive ? 'text-accent' : 'text-white'
                  }`}
                />
              </button>
            )
          }

          return (
            <Link
              key={index}
              href={item.href}
              className="flex flex-col items-center justify-center p-2 transition-all duration-200 hover:scale-105 hover:text-accent"
              aria-label={item.label}
            >
              <Icon
                className={`h-8 w-8 transition-colors ${
                  item.isActive ? 'text-accent' : 'text-white'
                }`}
              />
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
